import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { AgGridTableRef } from '@shared/components/ui/AgGridTable/types';
import React, { useCallback, useRef } from 'react';
import { useHistoryAgGridColumns } from '../../hooks/useHistoryAgGridColumns';
import { ShippingRulePresetApplication } from '../../models/ShippingRulePresetApplication';

interface HistoryAgGridTableProps {
  applications: ShippingRulePresetApplication[];
  selectedColumns?: string[];
  isFetching?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}

// Tabla AG Grid del historial de aplicaciones de presets
export const HistoryAgGridTable = React.memo(function HistoryAgGridTable({
  applications,
  selectedColumns = [],
  isFetching = false,
  isFetchingNextPage = false,
  fetchNextPage,
  hasNextPage,
}: HistoryAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);
  const { columnDefs } = useHistoryAgGridColumns(selectedColumns);

  const handleGridReady = useCallback(() => {}, []);

  return (
    /* Wrapper que aplica opacidad durante búsquedas sin desmontar la tabla (regla crítica AG Grid) */
    <div className={`w-full ${isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none' : ''}`}>
      <AgGridTable
        ref={agGridRef}
        data={applications}
        columnDefs={columnDefs}
        height="calc(100vh - 280px)"
        enableSelection={false}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        gridOptions={{}}
      />
    </div>
  );
});
